import { createRouter, createWebHashHistory } from 'vue-router';
import WelcomeView from './views/WelcomeView.vue';
import MenuView from './views/MenuView.vue';
import ConfirmView from './views/ConfirmView.vue';
import PayView from './views/PayView.vue';
import DoneView from './views/DoneView.vue';
import ReceiptView from './views/ReceiptView.vue';

/**
 * 触屏机的页面路由。
 *
 * 用 hash 模式而不是 history 模式：门店的触屏机可能是直接
 * `file://` 或者某个内嵌浏览器打开的，history 模式在那种环境下刷新会 404。
 * hash 模式在什么环境下都能活。
 */
const router = createRouter({
  history: createWebHashHistory(),
  routes: [
    { path: '/', name: 'welcome', component: WelcomeView },
    { path: '/menu', name: 'menu', component: MenuView },
    { path: '/confirm', name: 'confirm', component: ConfirmView },
    { path: '/pay', name: 'pay', component: PayView },
    { path: '/done', name: 'done', component: DoneView },

    /**
     * 电子小票（顾客扫码后在自己手机上打开的那一页）。
     * 业务规则：不用纸质小票取餐，凭付完款生成的电子小票取餐。
     * 参数走 query：?o=订单号&k=顾客凭据（后端查单必须带凭据，否则 404）。
     */
    { path: '/receipt', name: 'receipt', component: ReceiptView },
    // 任何奇怪的地址都回首页，触屏机不能停在白屏上
    { path: '/:pathMatch(.*)*', redirect: '/' },
  ],
});

export default router;
